import React from 'react';
import './ImgBlock.less';

const ImgBlock = ({images}) => (
    <div className="careers-img-block">
        {images.map(({primaryImageUrl}, i) => (
            <img src={primaryImageUrl} key={`culture-img-${i}`} />
        ))}
    </div>
);

export default ImgBlock;
